import { t, Trans } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useState } from "react";
import { useFragment } from "react-relay";

import { BookModal } from "@/features/BookModal";
import { Button } from "@whoosh/design-system/src/components/controls";
import { Text } from "@whoosh/design-system/src/components/primitive";

import { BookButtonHomeHeader_session$key } from "./__generated__/BookButtonHomeHeader_session.graphql";

type Props = {
  sessionRef: BookButtonHomeHeader_session$key | null;
  onNavigate?: () => void;
};

export const BookButtonHomeHeader = ({ sessionRef, onNavigate }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const session = useFragment(BookButtonHomeHeaderFragmentString, sessionRef);

  return (
    <>
      <Button
        onPress={() => {
          setIsModalOpen(true);
        }}
        size="tiny"
        width="100%"
        accessibilityLabel={t`Book Now button`}
      >
        <Text
          marginLeft={{ base: 0, lg: 2 }}
          color={"text-inverse"}
          variant="mainTiny"
          mb={0}
        >
          <Trans>Book Now</Trans>
        </Text>
      </Button>
      <BookModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onNavigate={onNavigate}
        sessionRef={session ?? null}
      />
    </>
  );
};

const BookButtonHomeHeaderFragmentString = graphql`
  fragment BookButtonHomeHeader_session on Session {
    ...BookModal_session
  }
`;
